import { render, staticRenderFns } from "./WikaPassLabel.vue?vue&type=template&id=35183509&"
import script from "./WikaPassLabel.vue?vue&type=script&lang=js&"
export * from "./WikaPassLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports